import * as D from 'io-ts/Decoder';

import { Request as DesignTransactionsRequest } from '../../../../api/report/design-transactions/request/Request';

export const DesignTransactionsType = D.partial({
	request: DesignTransactionsRequest,
	columns: D.partial({
		hidden: D.record(D.literal(true)),
		order: D.array(D.string),
	}),
	filters: D.partial({
		secondary: D.array(D.string),
	}),
});
